import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPlay, FaPause, FaVolumeUp, FaVolumeMute, FaArrowRight, FaYoutube } from 'react-icons/fa';
import './Banner.css';

// Placeholder image optimisée (base64)
const getPlaceholderImage = () => {
  return 'data:image/svg+xml;base64,' + btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="450" viewBox="0 0 800 450">
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#1069d3;stop-opacity:0.08" />
          <stop offset="100%" style="stop-color:#dc143c;stop-opacity:0.08" />
        </linearGradient>
      </defs>
      <rect width="800" height="450" fill="url(#grad)"/>
      <rect x="300" y="175" width="200" height="100" rx="10" fill="rgba(255,255,255,0.95)" stroke="#1069d3" stroke-width="2"/>
      <path d="M340 220 L380 220 L380 240 L340 240 Z" fill="#1069d3" fill-opacity="0.8"/>
      <circle cx="360" cy="230" r="15" fill="none" stroke="#1069d3" stroke-width="2" stroke-opacity="0.8"/>
      <circle cx="360" cy="230" r="5" fill="#1069d3" fill-opacity="0.8"/>
    </svg>
  `);
};

const Banner = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const videoPlayerRef = useRef(null);
  const bannerRef = useRef(null);

  // Informations de la vidéo YouTube
  const bannerVideo = {
    id: 1,
    videoId: 'Ujv0rbV_4l8',
    videoUrl: 'https://www.youtube.com/watch?v=Ujv0rbV_4l8',
    thumbnail: 'https://img.youtube.com/vi/Ujv0rbV_4l8/maxresdefault.jpg',
    title: 'Poursuivre ses études en France',
    duration: '2:30'
  };

  // Ouvrir la modal vidéo
  const openVideoModal = () => {
    setShowVideoModal(true);
    setIsPlaying(true);
  };

  // Fermer la modal vidéo
  const closeVideoModal = () => {
    setShowVideoModal(false);
    setIsPlaying(false);
  };

  return (
    <div className="hero-banner-container" ref={bannerRef}>
      {/* Fond clair avec motifs subtils */}
      <div className="hero-banner-background"></div>
      
      {/* Overlay artistique moderne */}
      <div className="hero-banner-artistic-overlay">
        <div className="hero-banner-wave hero-banner-wave-1"></div>
        <div className="hero-banner-wave hero-banner-wave-2"></div>
        <div className="hero-banner-wave hero-banner-wave-3"></div>
      </div>
      
      {/* Motif géométrique subtil */}
      <div className="hero-banner-geometric-pattern"></div>
      
      <div className="hero-banner-main-content">
        <div className="hero-banner-text-section">
          <div className="hero-banner-title-wrapper">
            <h1 className="hero-banner-main-title">
              <span className="hero-banner-title-line">Vous êtes un étudiant africain</span>
              <span className="hero-banner-title-line">ou international et vous souhaitez</span>
              <span className="hero-banner-title-line">poursuivre vos études en France ?</span>
            </h1>
            <div className="hero-banner-title-underline"></div>
          </div>
          
          <p className="hero-banner-description">
            <span className="hero-banner-highlight">Inscription 2026</span> - Votre avenir académique commence ici
          </p>
          
          <div className="hero-banner-action-buttons">
            <Link to="/inscription" className="hero-banner-action-btn hero-banner-btn-primary">
              <span className="hero-banner-btn-content">
                <span className="hero-banner-btn-text">S'inscrire maintenant</span>
                <span className="hero-banner-btn-icon">
                  <FaArrowRight />
                </span>
              </span>
            </Link>
            
            <Link to="/contact" className="hero-banner-action-btn hero-banner-btn-secondary">
              <span className="hero-banner-btn-content">
                <span className="hero-banner-btn-text">Nous contacter</span>
              </span>
            </Link>
          </div>
        </div>
        
        <div className="hero-banner-media-section">
          <div className="hero-banner-video-wrapper">
            <div className="hero-banner-accent-badge">
              <FaYoutube className="hero-banner-badge-youtube-icon" />
              <span>Vidéo 2026</span>
            </div>
            
            <div 
              className="hero-banner-video-frame"
              onClick={openVideoModal}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* Thumbnail de la vidéo - NOUVELLE STRUCTURE AVEC HAUTEUR FORCÉE */}
              <div className="hero-banner-video-thumbnail">
                <img 
                  src={bannerVideo.thumbnail}
                  alt="Poursuivre ses études en France"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = `https://img.youtube.com/vi/${bannerVideo.videoId}/hqdefault.jpg`;
                  }}
                />
                <div className="hero-banner-video-overlay">
                  <div className="hero-banner-play-button">
                    <FaPlay className="hero-banner-play-icon" />
                  </div>
                  <div className="hero-banner-video-duration">{bannerVideo.duration}</div>
                </div>
                {isHovered && (
                  <div className="hero-banner-video-hover-effect">
                    <div className="hero-banner-hover-wave"></div>
                  </div>
                )}
              </div>
              
              <div className="hero-banner-youtube-badge">
                <FaYoutube />
                <span>YouTube</span>
              </div>
            </div>
            
            {/* Décoration des coins */}
            <div className="hero-banner-corner-decoration hero-banner-corner-1"></div>
            <div className="hero-banner-corner-decoration hero-banner-corner-2"></div>
            <div className="hero-banner-corner-decoration hero-banner-corner-3"></div>
            <div className="hero-banner-corner-decoration hero-banner-corner-4"></div>
          </div>
        </div>
      </div>

      {/* Modal Vidéo */}
      {showVideoModal && (
        <div className="hero-banner-video-modal" onClick={closeVideoModal}>
          <div className="hero-banner-video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="hero-banner-modal-close" onClick={closeVideoModal}>
              ×
            </button>
            <div className="hero-banner-video-container-modal">
              <iframe
                ref={videoPlayerRef}
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${bannerVideo.videoId}?autoplay=1&rel=0&modestbranding=1`}
                title="Poursuivre ses études en France"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="hero-banner-video-modal-info">
              <h3>Poursuivre ses études en France</h3>
              <p>Découvrez comment ETEF vous accompagne dans votre projet d'études en France</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banner;